export default {
    createBehavior_newMetric: "Crear Nueva Métrica",
    createBehavior_editMetric: "Editar Métrica Para",
    createBehavior_selectAMetricOption: 'Por favor, selecciona una opción de métrica',
    createBehavior_createMetric_success: 'Métrica Creada Exitosamente',
    createBehavior_updateMetric_success: 'Métrica Actualizada Exitosamente',
    createBehavior_metricValueRequired: 'Se requieren valores de métrica',
    behavior_metricHasAlready: 'Esta métrica ya se ha creado.',
}
